<template>
    <div class="card-button-view-wrapper">
        <CardChangingButton
            class="card-btn"
            v-for="card in getCardList()"
            :key="card.id"
            :cardId="card.id"
            :cardIcon="card.cardIcon"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CardChangingButton from './CardChangingButton.vue'
export default {
    name: 'CardButtonViewM',
    components: {
        CardChangingButton,
    },
    computed: {
        ...mapGetters(['getCardList']),
    },
}
</script>

<style lang="scss" scoped>
@media (orientation: portrait) {
    .card-button-view-wrapper {
        width: 90%;
        height: fit-content;
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
    }
    .card-btn {
        width: 16%;
        aspect-ratio: 1/1;
        padding: 2%;
        margin: 2.5%;
    }
}
@media (orientation: landscape) {
    .card-button-view-wrapper {
        height: 100%;
        width: 20vw;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-evenly;
        align-items: center;
    }
    .card-btn {
        height: 15%;
        aspect-ratio: 1/1;
        padding: 2%;
        margin: 0 2%;
    }
}
</style>
